import { withBreakpointObserver } from '@studiometa/js-toolkit';
import {
  Slider as SliderCore,
  SliderDrag,
  SliderProgress,
  SliderItem,
  SliderDots,
  SliderBtn,
} from '@studiometa/ui';

/**
 * @typedef {import('@studiometa/ui').SliderProps} SliderCoreProps
 * @typedef {import('@studiometa/js-toolkit').WithBreakpointObserverProps} WithBreakpointObserverProps
 * @typedef {WithBreakpointObserverProps & SliderCoreProps & {
 *   $children: {
 *     SliderDrag: SliderDrag[],
 *     SliderItem: SliderItem[],
 *     SliderProgress: SliderProgress[],
 *     SliderDots: SliderDots[],
 *     SliderBtn: SliderBtn[],
 *   }
 * }} SliderProps
 */

/**
 * SliderHero.
 * @augments {SliderCore<SliderProps>}
 */
export default class SliderHero extends withBreakpointObserver(SliderCore) {
  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'SliderHero',
    components: {
      SliderDrag,
      SliderItem,
      SliderProgress,
      SliderDots,
      SliderBtn,
    },
  };
  /**
   * Mounted
   */
  mounted() {
    console.log('Mounted SliderHero');

    super.mounted();
    this.timer();
  }

  /**
   * Set an interval to change slide
   */
  timer() {
    this.interval = setInterval(() => {
      if (this.currentIndex < this.indexMax) {
        this.goNext();
      } else {
        this.goTo(0);
      }
    }, 6000);
  }

  /**
   * On dots click reset interval
   */
  onSliderDotsClick() {
    clearInterval(this.interval);
    this.timer();
  }
}
